'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _Box = require('./Box');

var _Box2 = _interopRequireDefault(_Box);

var _theme = require('./theme');

var _theme2 = _interopRequireDefault(_theme);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledSystem = require('styled-system');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var boxShadow = function boxShadow(props) {
  var boxShadows = {
    sm: _theme2.default.boxShadows[0],
    md: _theme2.default.boxShadows[1],
    lg: _theme2.default.boxShadows[2],
    xl: _theme2.default.boxShadows[3]
  };
  return { boxShadow: boxShadows[props.boxShadowSize] };
};

var boxBorder = function boxBorder(props) {
  return {
    border: props.borderWidth > 0 ? props.borderWidth + 'px solid ' + props.theme.colors[props.borderColor] : null
  };
};

var Card = (0, _styledComponents2.default)(_Box2.default)([], boxShadow, boxBorder, _styledSystem.borderRadius);

Card.propTypes = _extends({
  /** use scale alias for theme values or null to remove shadow */
  boxShadowSize: _propTypes2.default.oneOf([null, 'sm', 'md', 'lg', 'xl']),
  borderColor: _propTypes2.default.string
}, _styledSystem.propTypes.borderRadius, {
  /** use 0 to remove border */
  borderWidth: _propTypes2.default.oneOf([0, 1, 2])
});

Card.defaultProps = {
  theme: _theme2.default,
  borderColor: 'smoke',
  borderRadius: 1,
  borderWidth: 0
};

Card.displayName = 'Card';

exports.default = Card;